var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.875C3.27273 1.875 0.943636 3.57136 0 5.96591C0.943636 8.36045 3.27273 10.0568 6 10.0568C8.72727 10.0568 11.0564 8.36045 12 5.96591C11.0564 3.57136 8.72727 1.875 6 1.875ZM6 8.69318C4.49455 8.69318 3.27273 7.47136 3.27273 5.96591C3.27273 4.46045 4.49455 3.23864 6 3.23864C7.50545 3.23864 8.72727 4.46045 8.72727 5.96591C8.72727 7.47136 7.50545 8.69318 6 8.69318ZM6 4.32955C5.09455 4.32955 4.36364 5.06045 4.36364 5.96591C4.36364 6.87136 5.09455 7.60227 6 7.60227C6.90545 7.60227 7.63636 6.87136 7.63636 5.96591C7.63636 5.06045 6.90545 4.32955 6 4.32955Z",
    fill: "#002466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.420ef459d4ea30db938ac18ce5dc38eb.svg";
export { ForwardRef as ReactComponent };